










































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import Header from "@/components/Header.vue";
import { MeasureType } from "@/store/modules/enums";

@Component({
  components: {
    Header,
  },
  computed: {
    ...mapGetters("auth", ["userMeasureTypes", "userCalendars"]),
  },
})
export default class Home extends Vue {
  get MeasureType() {
    return MeasureType;
  }
}
